<template>
  <NuxtLink :to="`${notification.contexts.item_diary.link}`" class="wrapper">
    <div class="avatar">
      <img loading="lazy" :src="notification.contexts.item_diary.avatar_little" :alt="notification.contexts.item_diary.name" />
    </div>
    <div class="body">
      <div class="title">{{ notification.contexts.item_diary.name }}</div>
    </div>
  </NuxtLink>
  
</template>

<script setup lang="ts">
 
 const props = defineProps<{ notification: Notification }>()

</script>

<style scoped>

.wrapper{
  display:flex;
  flex-direction:row;
  align-items:center;
  gap:1rem;
}

.body{
  display:flex;
  flex-direction:column;
  gap:0.5rem;
}

.title{
  font-weight:600;
}

.avatar{
  width:3rem;
  height:3rem;
  aspect-ratio: 1/1;
  object-fit: cover;
}

.avatar img{
  width:100%;
  height:100%;
  object-fit: cover;
  border-radius:5px;
}

</style> 